import { Component, Input } from '@angular/core';
import { getGSTFilingDelay } from '../utils/helpers';

export interface GSTRecord {
  gstin: string;
  state: string;
  stateCode: string;
  activeStatus: string;
}

export interface GSTFilingRecord {
  gstin: string;
  rtntype: string;
  retPrd: string;
  dof: string;
  arn: string;
  status: string;
  mof: string;
  valid: string;
}

export interface GSTIDS {
  activeGSTIDS: string[];
  inactiveGSTIDS: string[];
}

interface FilingDelayResult {
  isLate: boolean;
  daysLate?: number;
}

@Component({
  selector: 'app-gst-compliance-card',
  templateUrl: './gst-compliance-card.component.html',
  styleUrls: ['./gst-compliance-card.component.scss']
})
export class GstComplianceCardComponent {
  @Input() activeGSTData: GSTRecord[] = [];
  @Input() gstFilingData: GSTFilingRecord[] = [];
  @Input() gstIDS: GSTIDS = { activeGSTIDS: [], inactiveGSTIDS: [] };

  get hasActiveGST(): boolean {
    return this.activeGSTData.length > 0;
  }

  get totalFilings(): number {
    return this.gstFilingData.length;
  }

  get delayedFilings(): number {
    return this.gstFilingData.filter(filing =>
      getGSTFilingDelay(filing.rtntype, filing.dof).isLate
    ).length;
  }

  get onTimeFilings(): number {
    return this.totalFilings - this.delayedFilings;
  }

  get overallFilingStatus(): { text: string; className: string } {
    if (this.delayedFilings === 0) {
      return { text: 'EXCELLENT', className: 'bg-green-100 text-green-800' };
    }
    return { text: 'NEEDS ATTENTION', className: 'bg-yellow-100 text-yellow-800' };
  }

  get activeGSTINsString(): string {
    return this.gstIDS.activeGSTIDS.join(', ') || 'N/A';
  }

  get inactiveGSTINsString(): string {
    return this.gstIDS.inactiveGSTIDS.join(', ') || 'N/A';
  }

}

